const dynamicPrice = (dynamicPercent = false) => {
  const ENV = process.env.NODE_ENV;
  let apiURL = 'https://web-stag.elsanow.co';

  if (ENV === 'production') {
    apiURL = 'https://elsaspeak.com';
  }

  var discount_code = $('input[name=discount_code]').val();
  if (discount_code && discount_code !== '') {
    $.ajax({
      method: 'get',
      dataType: 'json',
      url: `${apiURL}/api/get-price-by-code?code=${discount_code}`,
      success: function (response) {
        $('.one_year_price_base').text(response.data[discount_code].base_prices.one_year_credit.toLocaleString('en-US'));
        $('.one_year_price').text(response.data[discount_code].discount_prices.one_year_credit.toLocaleString('en-US'));
        $('input[name=membership][value=one_year_credit]').data('price', response.data[discount_code].discount_prices.one_year_credit);
        $('.lifetime_membership_price_base').text(response.data[discount_code].base_prices.lifetime_membership.toLocaleString('en-US'));
        $('.lifetime_membership_price').text(response.data[discount_code].discount_prices.lifetime_membership.toLocaleString('en-US'));
        $('input[name=membership][value=lifetime_membership]').data('price', response.data[discount_code].discount_prices.lifetime_membership);
        if(dynamicPercent) {
          $('.lifetime_percent').text(Math.round(response.data[discount_code].discount_percent.lifetime_membership));
          $('.one_year_percent').text(Math.round(response.data[discount_code].discount_percent.one_year_credit));
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log('The following error occured: ' + textStatus, errorThrown);
      }
    });
  }
}

export default dynamicPrice;
